/** @format */
import isPropValid from '@emotion/is-prop-valid';
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import { styles } from './blockquote.styles';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface BlockquoteProps {
    /**
     * The quote to display
     */
    quote: ReactNode;

    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;
}

const StyledBlockquote = styled('blockquote').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})<Omit<BlockquoteProps, 'quote'>>`
    ${styles}
`;

export const Blockquote: FunctionComponent<BlockquoteProps> = ({
    quote,
    ...otherProps
}: BlockquoteProps) => {
    return <StyledBlockquote {...otherProps}>{quote}</StyledBlockquote>;
};
